import AOS from "aos";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../assets/css/Seminar.css";
import data from "../ApiUrl/meta_api.js";

function Seminar() {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const HomeMeta = data[0]?.seminar_page;
    if (HomeMeta) setMeta(HomeMeta);

    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Seminar "}</title>
        <link
          rel="canonical"
          href="https://skimitaracademy.com/seminars"
        />
      </Helmet>

      {/* BANNER */}
      <div
        className="backgroundCommenImage mb-5 d-flex align-items-center"
        style={{
          backgroundImage: `url(${require("../../assets/images/Intern/Seminar/Seminor-1N.webp")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px",
        }}
      >
        <div className="backgroundcommenImageBannerText"></div>
      </div>

      {/* INTRO */}
      <div className="container">
        <h1 className="text-danger text-center mb-3">
          Seminars for Professional Excellence
        </h1>

        <p className="text-dark text-justify">
          Skimitar Hindusthan Training Institute, we offer dynamic and
          insightful seminars on Industrial Automation and Digital
          Marketing, designed to inspire and educate professionals,
          students, and industry leaders. Our seminars provide participants
          with the latest knowledge, trends, and practical strategies to
          excel in their respective fields.
        </p>
      </div>

      {/* INDUSTRIAL AUTOMATION */}
      <div className="container mt-5 mb-5">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <img
              className="img-fluid"
              style={{ width: "100%", height: "auto" }}
              src={require("../../assets/images/Intern/Seminar/engineer-cooperation-male-female-technician-maintenance-control-relay-robot-arm-system-welding-with-ta.webp")}
              alt=""
            />
          </div>

          <div className="col-12 col-md-6">
            <h3 className="text-danger our_ind text-md-start text-center">
              Our Industrial Automation Seminars
            </h3>

            {[
              "Introduction to Industrial Automation: Basics and benefits of automation in modern industries.",
              "Future of Automation: Trends and innovations shaping the industry.",
              "PLC and SCADA Systems: Real-world applications and advancements.",
              "Smart Manufacturing: Embracing IoT and Industry 4.0.",
              "Troubleshooting Automation Systems: Practical strategies for operational excellence.",
              "Insights from industry experts with years of hands-on experience.",
              "Live demonstrations of automation tools and techniques.",
              "Networking opportunities with professionals from diverse sectors."
            ].map((item, i) => (
              <p key={i} className="AutomationSeminars text-justify">
                <i
                  className="fa-solid fa-circle me-2"
                  style={{ color: "#dc3545", fontSize: "12px" }}
                ></i>
                {item}
              </p>
            ))}
          </div>
        </div>
      </div>

      {/* DIGITAL MARKETING */}
      <div className="container mb-5">
        <div className="row align-items-center flex-column-reverse flex-md-row">
          <div className="col-12 col-md-6">
            <h3 className="text-danger our_dig text-md-start text-center">
              Digital Marketing Seminars
            </h3>

            {[
              "The Power of Digital Marketing: How it’s reshaping businesses globally.",
              "Social Media Strategies: Building impactful campaigns on platforms like Instagram, Facebook, and LinkedIn.",
              "Search Engine Trends: SEO techniques for higher visibility and rankings.",
              "Content is King: Strategies for creating impactful and engaging content.",
              "Analytics and Metrics: Decoding data for better campaign optimization.",
              "Understanding the latest tools and technologies in digital marketing.",
              "Strategies to enhance brand visibility and ROI.",
              "Practical case studies from real-world campaigns."
            ].map((item, i) => (
              <p key={i} className="DigitalMarketing text-justify">
                <i
                  className="fa-solid fa-circle me-2"
                  style={{ color: "#dc3545", fontSize: "12px" }}
                ></i>
                {item}
              </p>
            ))}
          </div>

          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <img
              className="img-fluid"
              style={{ width: "100%", height: "auto" }}
              src={require("../../assets/images/Intern/Seminar/pexels-kindelmedia-7688336.webp")}
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Seminar;
